import React from "react";
import { styled } from '@mui/material/styles';

import axios from "axios";
import { getApiRoot } from "../../../helpers/Utils";
import {
  Grid,
  TableBody,
  TableHead,
  TableContainer,
  TableRow,
  Paper,
  CircularProgress
} from "@mui/material";
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function ApplicationFees() {
  const [years, setYears] = React.useState([]);
  const [isLoading, setLoading] = React.useState(true);
  
  React.useEffect(() => {
    axios.get(getApiRoot() + "/api/metrics?type=monthly").then((response) => {
  
      if (response.status !== 200) throw response.data;
      setYears(groupByYear(response.data));
      setLoading(false);
      // console.log("Fetched metrics ");
      // console.log(response.data);
      // setClubTypes(sort(sorting, response.data));
    });
  }, []);

 
  const groupByYear = (months) => {
    const map = {};
    for (const month of months) {
      if(!map[month.year]) {
        map[month.year] = {
          year: month.year,
        }
      }
      map[month.year][month.month] = month;
    }
    return Object.values(map);
  }

  const getMonthValue = (month, year) => {
    if(year[month]) {
      return year[month].applicationfee
    }
    return "-"
  }

  const getTableRow = (year) => {
    return (
      <StyledTableRow key={year.year}>
              <StyledTableCell component="th" scope="row">
                {year.year}
              </StyledTableCell>
              <StyledTableCell align="right">{getMonthValue(1, year)}</StyledTableCell>
              <StyledTableCell align="right">{getMonthValue(2, year)}</StyledTableCell>
              <StyledTableCell align="right">{getMonthValue(3, year)}</StyledTableCell>
              <StyledTableCell align="right">{getMonthValue(4, year)}</StyledTableCell>
              <StyledTableCell align="right">{getMonthValue(5, year)}</StyledTableCell>
              <StyledTableCell align="right">{getMonthValue(6, year)}</StyledTableCell>
              <StyledTableCell align="right">{getMonthValue(7, year)}</StyledTableCell>
              <StyledTableCell align="right">{getMonthValue(8, year)}</StyledTableCell>
              <StyledTableCell align="right">{getMonthValue(9, year)}</StyledTableCell>
              <StyledTableCell align="right">{getMonthValue(10, year)}</StyledTableCell>
              <StyledTableCell align="right">{getMonthValue(11, year)}</StyledTableCell>
              <StyledTableCell align="right">{getMonthValue(12, year)}</StyledTableCell>
            </StyledTableRow>
    )
  }

  return (
    <TableContainer component={Paper}>
      <TableHead>
        <TableRow>
            <StyledTableCell>Year</StyledTableCell>
            <StyledTableCell align="right">January</StyledTableCell>            
            <StyledTableCell align="right">February</StyledTableCell>            
            <StyledTableCell align="right">March</StyledTableCell>            
            <StyledTableCell align="right">April</StyledTableCell>            
            <StyledTableCell align="right">May</StyledTableCell>            
            <StyledTableCell align="right">June</StyledTableCell>            
            <StyledTableCell align="right">July</StyledTableCell>            
            <StyledTableCell align="right">August</StyledTableCell>            
            <StyledTableCell align="right">September</StyledTableCell>            
            <StyledTableCell align="right">October</StyledTableCell>            
            <StyledTableCell align="right">November</StyledTableCell>            
            <StyledTableCell align="right">December</StyledTableCell>            
        </TableRow>
      </TableHead>
        <TableBody>
          {isLoading ? <Grid direction="column"
                alignItems="center"
                justifyContent="center"
                container sx={{m:5, minHeight: '10vh'}}><CircularProgress/></Grid> : years.map((year) => getTableRow(year))}              
        </TableBody>        
    </TableContainer>
  );

}

export default ApplicationFees;
